import React from 'react';
import { Box, Flex } from '@chakra-ui/react';

export const BaseLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <Flex direction="column" height="100vh" bg="gray.50" w="100%">
      <Box flex="1" p={6}>
        {children}
      </Box>
    </Flex>
  );
}; 